import { z } from 'zod';

import {
  BaseFlowBlockSchema,
  BlockType,
  ProducedType,
  returnTypeSchema,
} from '../base/baseSchema.js';

export enum ProviderIDType {
  USER_ID = 'USER_ID',
  EHR_PROVIDER_INFORMATION_ID = 'EHR_PROVIDER_INFORMATION_ID',
}

export const GetProviderBlockConfigSchema = z
  .object({
    providerIdType: z.nativeEnum(ProviderIDType).optional(),
    providerId: z.string().optional(),
  })
  .refine(
    (data) => {
      return data.providerId ? data.providerIdType !== undefined : true;
    },
    {
      message: 'Provider id type is required if provider id is specified',
      path: ['providerIdType'],
    }
  );

export type GetProviderBlockConfig = z.infer<typeof GetProviderBlockConfigSchema>;

export const GetProviderBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.GetProvider),
  returnType: returnTypeSchema(ProducedType.Provider),
  config: GetProviderBlockConfigSchema,
});

export type GetProviderBlock = z.infer<typeof GetProviderBlockSchema>;
